import React from "react";
import { dirCondition, styleCondition } from "../inputsAlgorithms";
import Icon from "../icons/fontawsomeIcons";
import {
  getCurrentLangFromRedux,
  getDir,
} from "../../../algorithms/styleChanges";
const TextInput = ({
  placeholder,
  containerStyle,
  inputStyle,
  type,
  onChange,
  disable,
  height,
  width,
  style,
  iconName,
  iconSize,
  iconPrefix,
  name,
  value,
  errorMessage,
  hiddenPlaceholder,
  ref,
  direction,
  min,
  max,
}) => {
  const show = ["text", "password", "email", "number"].includes(type);
  return (
    <div
      className={`${
        String(containerStyle).includes("col")
          ? containerStyle
          : containerStyle + " col-3"
      }`}
      style={{ position: "relative" }}
    >
      {show ? (
        <input
          dir={direction ?? getDir(getCurrentLangFromRedux())}
          ref={ref}
          name={name}
          autoComplete={"off"}
          className={`${inputStyle}  text_input`}
          value={value}
          type={type ?? "text"}
          disabled={disable ?? false}
          onChange={onChange}
          placeholder={hiddenPlaceholder ?? " "}
          style={{
            direction: getDir(getCurrentLangFromRedux()),
            height: height ?? 45,
            width: styleCondition(width, 100, "%"),
            outline: "none",
            // ...style,
          }}
          min={min}
          max={max}
        ></input>
      ) : null}
      {iconName ? (
        <span className={`${dirCondition("text_input_icon")} m-1`}>
          <Icon
            size={iconSize ?? 20}
            iconPrefix={iconPrefix ?? "fas"}
            name={iconName}
          ></Icon>
        </span>
      ) : null}
      {!hiddenPlaceholder && placeholder ? (
        <span
          className={`${
            direction
              ? dirCondition("text_input_placeholder", direction)
              : dirCondition("text_input_placeholder")
          } `}
        >
          {placeholder}
        </span>
      ) : null}
      <div style={{ fontSize: 14, color: "red" }}> {errorMessage ?? ""}</div>
    </div>
  );
};

export default TextInput;
